import type { NextEditorPlugin } from '@atlaskit/editor-common/types';
import { createUniqueLocalIdPlugin } from './unique-local-id';

export const forgeEditorPlugin: NextEditorPlugin<'forgeExtension'> = () => ({
	name: 'forgeExtension',
	pmPlugins() {
		return [
			{
				name: 'forgeExtensionUniqueId',
				plugin: () => createUniqueLocalIdPlugin(),
			},
		];
	},
});
